<template>
  <div class="test">
    <div class="my-table">
      <div class="table-header">
        <div class="table-total">期号</div>
        <div class="second-header">
          <div class="header-total">红球号码分布</div>
          <ul class="header-item">
            <li
              v-for="(item, index) in redBallList"
              :key="index"
            >{{ item + 1 < 10 ? ('0' + (item + 1)) : item + 1 }}</li>
          </ul>
        </div>
        <div class="second-header">
          <div class="header-total">篮球号码分布</div>
          <ul class="header-item">
            <li
              v-for="(item, index) in blueBallList"
              :key="index"
            >{{ item + 1 < 10 ? ('0' + (item + 1)) : item + 1 }}</li>
          </ul>
        </div>
      </div>
      <div class="table-body">
        <div class="tr" v-for="(item, index) in dataList" :key="index">
          <div class="td">{{ item.key }}</div>
          <div class="red-list">
            <div class="td" v-for="(it, idx) in redBallList" :key="idx">
              <div
                class="ball"
                :class="{ show: item.redData && item.redData.includes(it - 1) }"
              >{{ item.redData && item.redData.includes(it - 1) ? it + 1 : '' }}</div>
            </div>
          </div>
          <div class="blue-list">
            <div class="td" v-for="(it, idx) in blueBallList" :key="idx">
              <div
                class="ball"
                :class="{ show: item.blueData && item.blueData.includes(it - 1) }"
              >{{ item.blueData && item.blueData.includes(it - 1) ? it + 1 : '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      redBallList: [...Array(33).keys()],
      blueBallList: [...Array(16).keys()],
      dataList: [],
      current: 1
    };
  },
  created() {
    const result = [];
    [...Array(10).keys()].map(item => {
      result.push(this.shuffle());
      this.current++;
    });
    this.dataList = result;
  },
  methods: {
    getKey() {
      return this.current < 10
        ? "00" + this.current
        : this.current < 100
        ? "0" + this.current
        : this.current;
    },
    getRandomIndex(count, array, result = []) {
      if (count === result.length) {
        return result;
      } else {
        result.push(
          ...array.splice(Math.floor(Math.random() * array.length), 1)
        );
        this.getRandomIndex(count++, array, result);
      }
    },
    shuffle() {
      const redData = [],
        blueData = [];
      this.getRandomIndex(7, [...Array(33).keys()], redData);
      this.getRandomIndex(1, [...Array(16).keys()], blueData);
      return {
        key: `${new Date().getFullYear()}-${this.getKey()}`,
        redData: redData,
        blueData: blueData
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.test {
  padding: 20px 0;
}
.my-table {
  width: 90%;
  margin: 0 auto;
  border: 1px solid #ccc;
  .table-header {
    border-bottom: 1px solid #ccc;
  }
  .table-header,
  .header-item {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .second-header {
    flex: 5;
    border-right: 1px solid #ccc;
    li {
      height: 26px;
      line-height: 26px;
      flex: 1;
      border-right: 1px solid #ccc;
      background-color: #f4f4f4;
      &:last-child {
        border-right: 0;
      }
    }
    &:last-child {
      border-right: 0;
      flex: 2;
    }
  }
  .header-total {
    height: 34px;
    line-height: 33px;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
  }
  .table-total {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    border-right: 1px solid #ccc;
    box-sizing: border-box;
  }

  .table-body {
    .tr {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      height: 30px;
      border-bottom: 1px solid #ccc;

      &:last-child {
        border-bottom: 0;
      }
      .td {
        border-right: 1px solid #ccc;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;

        .ball.show {
          width: 24px;
          height: 24px;
          border-radius: 12px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &:first-child {
          width: 100px;
        }

        &:last-child {
          border-right: 0;
        }
      }

      .red-list {
        border-right: 1px solid #ccc;

        .ball.show {
          background-color: red;
        }
      }

      .red-list,
      .blue-list {
        flex: 5;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;

        .td {
          flex: 1;
        }
      }

      .blue-list {
        flex: 2;

        .ball.show {
          background-color: blue;
        }
      }
    }
  }
}
</style>